export function getMax(arr: number[]) {
  return arr.reduce((max, v) => (max >= v ? max : v), -Infinity)
}
export function getMin(arr: number[]) {
  return arr.reduce((min, v) => (min <= v ? min : v), Infinity)
}
